var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-form"},[_c('Alert'),_c('RegisterFormForm',{ref:"registerForm",attrs:{"user":this.user,"mode":"create"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }